<div class="file-row" [dataSelector]="'cxp-deliverable-detail-file-row'">
  <span class="file-icon" aria-hidden="true">
    <aiwyn-icon [name]="iconName()" [width]="16" [height]="16"></aiwyn-icon>
  </span>

  <div class="file-info">
    <p class="file-name" [title]="file().name" [dataSelector]="'cxp-deliverable-detail-file-name'">{{ file().name }}</p>
    <p class="file-meta">
      @if (file().sizeBytes !== null) {
        <span [dataSelector]="'cxp-deliverable-detail-file-size'">{{ file().sizeBytes | fileSize: 1 }}</span>
      }
      @if (file().sizeBytes !== null && file().uploadedAt) {
        <span class="file-meta-sep" aria-hidden="true">•</span>
      }
      @if (file().uploadedAt; as uploadedAt) {
        <span [dataSelector]="'cxp-deliverable-detail-file-uploaded-at'">{{ uploadedAt | cxpRelativeTime }}</span>
      }
    </p>
  </div>

  <div class="file-actions" [dataSelector]="'cxp-deliverable-detail-file-actions'">
    <button
      andButton
      color="ghost"
      size="small"
      [dataSelector]="'cxp-deliverable-detail-preview-file'"
      [attr.aria-label]="'Preview ' + file().name"
      (click)="onPreviewClicked()"
    >
      <aiwyn-icon name="eye" class="icon-color-gray-500" [width]="16" [height]="16"></aiwyn-icon>
    </button>
    <button
      andButton
      color="ghost"
      size="small"
      [isLoading]="isDownloading()"
      [dataSelector]="'cxp-deliverable-detail-download-file'"
      [attr.aria-label]="'Download ' + file().name"
      (click)="onDownloadClicked()"
    >
      <aiwyn-icon name="download" class="icon-color-gray-500" [width]="16" [height]="16"></aiwyn-icon>
    </button>
  </div>
</div>
